import { ChakraV3 } from '@piccolohealth/ui';
import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../../../context/AuthContext';

export const MFAChooseMethodButton = () => {
  const auth = useAuth();

  const navigate = useNavigate();

  const onTryAnotherMethod = async () => {
    await navigate('/mfa/enrol');
  };

  if (!auth.showEnrolMfa) {
    return null;
  }

  return (
    <ChakraV3.Button
      variant='plain'
      fontWeight='semibold'
      size='md'
      w='fit-content'
      alignSelf='center'
      cursor='pointer'
      onClick={onTryAnotherMethod}
    >
      Try another method
    </ChakraV3.Button>
  );
};
